import {API_URL} from "../../dev";
import "isomorphic-fetch";

class VenueApi {
	async getVenue(merchantId, id) {
		try {
			const venueResponse = await fetch(`${API_URL}/v1/venues/${merchantId}/${id}`);
			const venueObj = await venueResponse.json();
			if (venueResponse.ok) {
				return venueObj;
			}
			throw venueObj;
		} catch (e) {
			console.error(`Error occurred in getVeneu ${id}: ${JSON.stringify(e)}`);
			throw e;
		}
	}
}

const venueApi = new VenueApi();
export default venueApi;
